export const deepGet = (object: Record<string, any>, objectPath: string): Record<string, any> | undefined => {
  return objectPath.split('.').reduce((previousObject, currentKey) => {
    if (previousObject && previousObject[currentKey] !== undefined) {
      return previousObject[currentKey];
    }
    return undefined;
  }, object);
};
